import React, { useEffect, useRef } from 'react';
import { FormGroup, Grid, Tooltip, Typography } from '@mui/material';
import { useAppSelector } from 'renderer/shared/state/hooks';
import { selectIsLoggedIn } from 'renderer/features/auth/state/userSelectors';
import { Field, useFormikContext } from 'formik';
import { CheckboxWithLabel, TextField as TextInput } from 'formik-mui';
import { AccountForm as AccountFormType } from 'renderer/features/purchase-page/schemas/purchase.schemas';
import { useParams } from 'react-router-dom';
import { useGetProductDetailsQuery } from 'renderer/features/products-page/services/products.endpoints';

interface AccountFormProps {
  disabled: boolean;
  hasSubscription: boolean;
  paymentProvider?: string;
}

const AccountForm: React.FC<AccountFormProps> = ({
  disabled,
  hasSubscription,
  paymentProvider,
}) => {
  console.log('AccountForm', { hasSubscription });
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const { id: productId } = useParams();
  const { data: productDetails } = useGetProductDetailsQuery(productId ?? '');
  const { values, setFieldValue } = useFormikContext<AccountFormType>();
  console.log('productDetails', productDetails);

  const isSubscription = productDetails?.category === 'Subscription';

  const didInit = useRef(false);

  useEffect(() => {
    if (didInit.current) return;
    // If the cart contains a subscription and user is public, enforce required fields once.
    if (
      (hasSubscription && !isLoggedIn) ||
      values.isNewPaymentMethod === true
    ) {
      // These set the initial required state but won't fight the user afterward.
      setFieldValue('createAccount', true, false);
      setFieldValue('savePayment', true, false);
    }

    didInit.current = true;
  }, [hasSubscription, isLoggedIn, setFieldValue, values.isNewPaymentMethod]);

  // uncheck savePayment automatically if createAccount is unchecked
  useEffect(() => {
    if (!values.createAccount && !isLoggedIn) {
      setFieldValue('savePayment', false, false);
    }
  }, [values.createAccount, setFieldValue, isLoggedIn]);

  // useEffect(() => {
  //   if (isSubscription && !isLoggedIn) {
  //     setFieldValue('createAccount', true);
  //     setFieldValue('savePayment', true);
  //   }
  // }, [isLoggedIn, isSubscription, setFieldValue]);

  // useEffect(() => {
  //   if (hasSubscription && !isLoggedIn) {
  //     setFieldValue('createAccount', true);
  //     setFieldValue('savePayment', true);
  //   }
  //   // setFieldValue('createAccount', true);
  //   // setFieldValue('savePayment', true);
  // }, [isLoggedIn, hasSubscription, setFieldValue]);

  // useEffect(() => {
  //   if (isSubscription && !isLoggedIn) {
  //     if (!values.createAccount) {
  //       setFieldValue('createAccount', true);
  //     }
  //     if (!values.savePayment) {
  //       setFieldValue('savePayment', true);
  //     }
  //   }
  // }, [
  //   isSubscription,
  //   isLoggedIn,
  //   setFieldValue,
  //   values.createAccount,
  //   values.savePayment,
  // ]);

  // Determine if the "createAccount" checkbox should be disabled
  const disableCreateAccount = hasSubscription && !isLoggedIn;
  const disableSavePayment = hasSubscription && !isLoggedIn;

  return (
    <>
      {!isLoggedIn && (
        <Typography variant="h6" sx={{ my: 2 }}>
          Contact
        </Typography>
      )}
      <Grid container spacing={2}>
        {!isLoggedIn && (
          <>
            <Grid item xs={12} sm={6}>
              <Field
                size="small"
                fullWidth
                component={TextInput}
                disabled={disabled}
                name="firstName"
                label="First Name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                size="small"
                fullWidth
                component={TextInput}
                disabled={disabled}
                name="lastName"
                label="Last Name"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                size="small"
                component={TextInput}
                disabled={disabled}
                name="email"
                label="Email"
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormGroup row>
            {!isLoggedIn && (
              <Tooltip
                title={
                  disableCreateAccount
                    ? 'Creating an account is required to make a subscription purchases.'
                    : ''
                }
                arrow
              >
                <span>
                  <Field
                    component={CheckboxWithLabel}
                    disabled={disabled || disableCreateAccount}
                    type="checkbox"
                    id="createAccount"
                    name="createAccount"
                    Label={{ label: 'Create an account' }}
                  />
                </span>
              </Tooltip>
            )}
            {((!isLoggedIn && values.createAccount) ||
              values.isNewPaymentMethod) &&
              paymentProvider !== 'paypal' && (
                <Field
                  component={CheckboxWithLabel}
                  disabled={disabled || disableSavePayment}
                  type="checkbox"
                  name="savePayment"
                  Label={{ label: 'Save this payment method' }}
                />
              )}

            {(isLoggedIn || values.createAccount) &&
              values.savePayment &&
              paymentProvider !== 'paypal' && (
                <Field
                  component={CheckboxWithLabel}
                  disabled={disabled}
                  type="checkbox"
                  name="makeDefault"
                  Label={{ label: 'Make this my default payment method' }}
                />
              )}
          </FormGroup>
        </Grid>
        {!isLoggedIn && values.createAccount && (
          <>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                size="small"
                component={TextInput}
                disabled={disabled}
                name="password"
                label="Password"
                type="password"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                size="small"
                component={TextInput}
                disabled={disabled}
                name="confirmPassword"
                label="Confirm Password"
                type="password"
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default AccountForm;
